const guildStatusOptions = [
  {
    value: 'draft',
    label: 'Draft',
    icon: 'draft',
    iconLibrary: 'material',
    description: 'Guild still being configured, limited functionality',
    tagVariant: 'default',
  },
  {
    value: 'live',
    label: 'Live',
    icon: 'online_prediction',
    iconLibrary: 'material',
    description: 'Active and collaborating',
    tagVariant: 'warning',
  },
  {
    value: 'archived',
    label: 'Archived',
    icon: 'inventory_2',
    iconLibrary: 'material',
    description: 'Still visible to members but inactive',
    tagVariant: 'danger',
  },
  {
    value: 'deleted',
    label: 'Deleted',
    icon: 'delete',
    iconLibrary: 'material',
    description: 'Removed from the network',
    tagVariant: 'danger',
  },
];
const guildStatusMap = Object.fromEntries(guildStatusOptions.map((o) => [o.value, o]));

const guildActivationStatusOptions = [
  { 
    value: 'created', 
    label: 'Draft',
    icon: 'pending', 
    iconLibrary: 'material', 
    description: 'This is a draft guild and is not yet available for interaction.',
    organizerNotes: 'Guild is in draft mode and cannot have members other than the point. Must be published before members can be invited.',
    tagVariant: 'default',
  },
  { 
    value: 'published', 
    label: 'Published', 
    icon: 'offline_bolt', 
    iconLibrary: 'material', 
    description: 'This guild is published, but still in the process of being activated.',
    organizerNotes: 'Guild is private, but active and can have members. To reach seeded status, onboard 10 members and post 10 log updates.',
    tagVariant: 'primary',
  },
  {
    value: 'seeded', 
    label: 'Seeded', 
    icon: 'lightbulb_circle', 
    iconLibrary: 'material', 
    description: 'This guild has been seeded with initial members and content, but is still in the process of being activated.',
    organizerNotes: 'Guild is seeded. It can be made public if desired and can connect with projects. To reach activated status, onboard 50 members and reach 50 log updates, including updates from member projects.',
    tagVariant: 'primary',
  },
  { 
    value: 'activated', 
    label: 'Activated', 
    icon: 'brightness_5', 
    iconLibrary: 'material', 
    description: 'This in an active guild.',
    organizerNotes: 'Guild is activated and gets increased visibility. A custom URL may be claimed. The Q1 Foundation team is available to organize an official launch.',
    tagVariant: 'warning',
  },
  { 
    value: 'launched', 
    label: 'Launched', 
    icon: 'brightness_7', 
    iconLibrary: 'material', 
    description: 'This guild is fully launched and active.',
    organizerNotes: 'Guild is fully launched and active. Launched guilds have the highest level of visibility & discoverability, and receive more support from the network.',
    tagVariant: 'warning',
  },
  { 
    value: 'retired', 
    label: 'Retired', 
    icon: 'do_not_disturb_on', 
    iconLibrary: 'material',
    description: 'This guild has been retired and is no longer active.',
    description: 'Guild is still available to old members, but is no longer active.',
    tagVariant: 'danger',
  },
];
const guildActivationStatusMap = Object.fromEntries(
  guildActivationStatusOptions.map((o) => [o.value, o])
);

const guildVisibilityOptions = [
  { 
    value: 'public',
    label: 'Public',
    icon: 'public',
    iconLibrary: 'material',
    description: 'Visible on the public internet',
    availableAt: ['seeded', 'activated', 'launched'],
  },
  {
    value: 'network',
    label: 'Network',
    icon: 'q1-logo',
    iconLibrary: 'q1',
    description: 'Visible to members of the q1 Network',
    availableAt: ['seeded', 'activated', 'launched'],
  },
  {
    value: 'link',
    label: 'Private Link',
    icon: 'link',
    iconLibrary: 'material',
    description: 'Guild is private & unlisted, visible to any q1 Network members with link.',
    availableAt: ['created', 'published', 'seeded', 'activated', 'launched', 'retired'],
  },
  {
    value: 'private',
    label: 'Private',
    icon: 'communities',
    iconLibrary: 'material',
    description: 'Only visible to members',
    availableAt: ['created', 'published', 'seeded', 'activated', 'launched', 'retired'],
  },
];
const guildVisibilityMap = Object.fromEntries(
  guildVisibilityOptions.map((o) => [o.value, o])
);

const guildJoinabilityOptions = [
  {
    value: 'open',
    label: 'Open',
    icon: 'handshake',
    iconLibrary: 'material',
    description: 'Anyone who can see the guild can join the guild directly.',
    requestable: true,
  },
  {
    value: 'request',
    label: 'By Request',
    icon: 'person_raised_hand',
    iconLibrary: 'material',
    description: 'Anyone who can see the guild can request to join, organizers must approve.',
    requestable: true,
  },
  {
    value: 'invite',
    label: 'By Invitation',
    icon: 'lock',
    iconLibrary: 'material',
    description: 'By organizer invitation only.',
    requestable: false,
  },
];
const guildJoinabilityMap = Object.fromEntries(guildJoinabilityOptions.map((o) => [o.value, o]));

const guildTextColorOptions = [
  { value: 'black', label: 'Black' },
  { value: 'white', label: 'White' },
];
const guildTextColorMap = Object.fromEntries(
  guildTextColorOptions.map((o) => [o.value, o])
);

/*=== EXPORTS ===*/

export {
  guildStatusOptions,
  guildStatusMap,

  guildActivationStatusOptions,
  guildActivationStatusMap,

  guildVisibilityOptions,
  guildVisibilityMap,
  
  guildJoinabilityOptions,
  guildJoinabilityMap,
  
  guildTextColorOptions,
  guildTextColorMap,
};
